import { ActionReducerMap } from '@ngrx/store';
import { authReducer, AuthState } from './auth/auth.store';
import { createPositionReducer, CreatePositionState } from './create-position/create-position.store';
import { dashboardReducer, DashboardState } from './dashboard/dashboard.store';
import { onboardingReducer, OnboardingState } from './onboarding/onboarding.store';
import { userReducer, UserState } from './user/user.store';

export interface AppState {
  auth: AuthState;
  user: UserState;
  onboarding: OnboardingState;
  createPosition: CreatePositionState;
  dashboard: DashboardState
}

export const appReducers: ActionReducerMap<AppState, any> = {
  auth: authReducer,
  user: userReducer,
  onboarding: onboardingReducer,
  createPosition: createPositionReducer,
  dashboard: dashboardReducer,
}
